import { webPushApi } from '../api/webPush';

const decodeVapidKey = (value) => {
  const padding = '='.repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/');
  const bytes = window.atob(base64);
  return Uint8Array.from(bytes, (char) => char.charCodeAt(0));
};

export const getPushSubscription = async () => {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
  const registration = await navigator.serviceWorker.getRegistration();
  if (!registration) return null;
  return registration.pushManager.getSubscription();
};

export const enablePushForCurrentBrowser = async (publicKey) => {
  const registration = await navigator.serviceWorker.getRegistration();
  if (!registration) throw new Error('Service worker is not registered');
  const existing = await registration.pushManager.getSubscription();
  const subscription = existing || await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: decodeVapidKey(publicKey),
  });
  await webPushApi.subscribe(subscription);
  return subscription;
};

export const restorePushForCurrentBrowser = async () => {
  const subscription = await getPushSubscription();
  if (subscription) await webPushApi.subscribe(subscription);
  return subscription;
};

export const disablePushForCurrentBrowser = async () => {
  const subscription = await getPushSubscription();
  if (!subscription) return;
  try {
    await webPushApi.unsubscribe(subscription.endpoint);
  } finally {
    await subscription.unsubscribe();
  }
};

export const setApplicationBadge = async (count) => {
  try {
    if (count > 0 && navigator.setAppBadge) await navigator.setAppBadge(count);
    if (count <= 0 && navigator.clearAppBadge) await navigator.clearAppBadge();
  } catch {
    // Badge support depends on the browser and installation mode.
  }
};
